export const CloseCommentEvent = "closeCommentWindow";
export const LoginSuccessQueryParameters = "comment_login_success";
